var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeco1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9 23.79s-17.97 5.12-17.7 20.46l-5.53-6.73s1.18-10.63 23.23-13.73zM19.67 6.95L25.2.22c-.28 15.35 17.7 20.46 17.7 20.46-22.05-3.1-23.23-13.73-23.23-13.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.14 17.79l1.96.39c9.76 1.96 19.67 3.07 29.62 3.3l32.72.76-32.71.76c-9.95.23-19.86 1.33-29.62 3.29l-1.97.4-9.3-4.45 9.3-4.45z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco1);
export default __webpack_public_path__ + "static/media/deco1.c30e68bfc8a9f0d36eb24223523ff2a6.svg";
export { ForwardRef as ReactComponent };